import React, { useState, useMemo } from 'react';
import { get } from 'lodash';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import { ConditionalLogicModeProps } from '../ConditionalLogic';
import { SearchInput } from '../../../../../../../common/components/SearchInput/SearchInput';
import Button from '../../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';

export const ConditionalLogicAudiences = (props: ConditionalLogicModeProps) => {
  const {
    setEditMode,
    conditionalAudiences,
    audiences,
    editWidget,
    setEditWidget,
  } = props;

  const audienceLookup = useMemo(
    () => new Map(audiences.map(a => [a.id, a] as [number, AudiencesModel])),
    [audiences],
  );
  const [searchText, setSearchText] = useState('');
  const unusedAudiences = useMemo(
    () =>
      audiences.filter(
        a =>
          !conditionalAudiences.find(ca => a.id === ca.audienceId) &&
          (!searchText || a.name.indexOf(searchText) >= 0),
      ),
    [audiences, conditionalAudiences, searchText],
  );

  const onRemoveAudience = (audienceId: number) => {
    setEditWidget({
      ...editWidget,
      conditionalAudiences: conditionalAudiences.filter(
        a => a.audienceId !== audienceId,
      ),
    });
  };

  const onAddAudience = (audienceId: number) => {
    setEditWidget({
      ...editWidget,
      conditionalAudiences: [...conditionalAudiences, { audienceId }],
    });
  };

  return (
    <div className="widget-conditional-logic__sub-section">
      <div className="widget-conditional-logic__header-text">
        <Button
          text
          className="widget-conditional-logic__back-button"
          onClick={() => setEditMode('root')}
        >
          <i className="fas fa-chevron-left" />
        </Button>
        Audiences
      </div>
      <div className="widget-conditional-logic__instructions">
        Applied audiences:
      </div>
      <div className="widget-conditional-logic__item-content">
        {conditionalAudiences.length === 0
          ? 'No audiences chosen'
          : conditionalAudiences.map((a, i) => (
              <>
                {i > 0 && (
                  <div className="widget-conditional-logic__item-content-item-separator">
                    OR
                  </div>
                )}
                <div
                  key={a.audienceId}
                  className="widget-conditional-logic__item-content-item"
                >
                  {get(audienceLookup.get(a.audienceId), 'name')}
                  <Button
                    className="widget-conditional-logic__item-content-item-action-button"
                    text
                    onClick={() => onRemoveAudience(a.audienceId)}
                  >
                    <i className="fas fa-times" />
                  </Button>
                </div>
              </>
            ))}
      </div>
      <div className="widget-conditional-logic__item-content">
        <SearchInput
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          placeholder="Search audiences"
        />
      </div>
      <div className="widget-conditional-logic__item-content">
        {unusedAudiences.length === 0
          ? 'No audiences available'
          : unusedAudiences.map(a => (
              <Button
                text
                key={a.id}
                className={
                  'widget-conditional-logic__item-content-item ' +
                  'widget-conditional-logic__item-content-item--eligible'
                }
                onClick={() => onAddAudience(a.id)}
              >
                {a.name}
                <div className="widget-conditional-logic__item-content-item-action-button">
                  <i className="fas fa-plus" />
                </div>
              </Button>
            ))}
      </div>
      <PrimaryButton
        className="widget-conditional-logic__add-button"
        onClick={() => setEditMode('root')}
      >
        Done
      </PrimaryButton>
    </div>
  );
};
